import React from "react"
import {
  Checkbox,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Tooltip,
  Typography
} from "@mui/material"
import { FileDownloadOutlined, SearchOutlined } from "@mui/icons-material"

interface Props {
  selectedCount: number
  allSelected: boolean
  someSelected: boolean
  searchQuery: string
  onSearchQueryChange: (value: string) => void
  onToggleSelectAll: () => void
  onExportSelected: () => void
  showSearch?: boolean
}

const ListingsToolbar: React.FC<Props> = ({
  selectedCount,
  allSelected,
  someSelected,
  searchQuery,
  onSearchQueryChange,
  onToggleSelectAll,
  onExportSelected,
  showSearch = false
}) => {
  return (
    <>
      <Stack direction="row" justifyContent="space-between" alignItems="center" gap={1} flexWrap="wrap">
        <Typography variant="h5" fontWeight="bold" fontSize={{ xs: "1rem", sm: "1.5rem" }}>
          My Listings
        </Typography>
        <Stack direction="row" alignItems="center" gap={1} flexWrap="wrap">
          <FormControlLabel
            control={<Checkbox checked={allSelected} indeterminate={someSelected} onChange={onToggleSelectAll} />}
            label={
              <Typography variant="body2" color="text.secondary">
                {selectedCount > 0 ? `${selectedCount} selected` : "Select"}
              </Typography>
            }
          />
          <Tooltip title={selectedCount === 0 ? "Select at least one product to export" : "Export selected as CSV"}>
            <span>
              <IconButton size="small" onClick={onExportSelected} disabled={selectedCount === 0}>
                <FileDownloadOutlined />
              </IconButton>
            </span>
          </Tooltip>
        </Stack>
      </Stack>
      <Stack direction="row" justifyContent="space-between" alignItems="center" display={showSearch ? "flex" : "none"}>
        <TextField
          size="small"
          placeholder="Search by name…"
          value={searchQuery}
          onChange={e => onSearchQueryChange(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchOutlined fontSize="small" />
              </InputAdornment>
            )
          }}
          sx={{ width: "100%" }}
        />
      </Stack>
    </>
  )
}

export default ListingsToolbar
